export default text => (text ? text.toLowerCase() : '');
